import {Component, Input, OnInit, Output, EventEmitter} from "@angular/core";
import {BoardService} from "../../../service/board/board.service";
import {Comment, CommentPost} from "../../../service/board/board";
import {AuthService} from "../../../service/auth/auth.service";
import {GtmService} from "../../../service/gtm/gtm.service";
import {ImageUploadService} from "../../../service/image/image.service";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-comment-rg',
  templateUrl: './comment-reg.component.html',
  styleUrls: ['./comment-reg.component.scss'],
  providers: [BoardService, DatePipe, ImageUploadService]
})
export class CommentReisterComponent implements OnInit {

  @Input() id: number;
  @Input() list: string;
  @Input() board: any;
  @Input() isReply: boolean;

  constructor(private boardService: BoardService,
              private authService: AuthService,
              private gtmService: GtmService,
              private imageService: ImageUploadService,
              private datePipe: DatePipe) {
  }

  ngOnInit() {
  }

  myPhoto(): string {
    return this.authService.me.photo || 'assets/images/member-default.png';
  }

  imageURL: string = ''
  imageHandler() {
    const Imageinput = document.createElement('input');
    Imageinput.setAttribute('type', 'file');
    Imageinput.setAttribute('accept', 'image/png, image/gif, image/jpeg');
    Imageinput.classList.add('ql-image');

    Imageinput.addEventListener('change', () =>  {
      const file = Imageinput.files;
      this.imageService.makeFileRequest('/api/file-uploads', file).then(
        (result) => {
          // console.log(result['filename'])
          this.imageURL = result['filename'];
        },
      )
    });

    Imageinput.click();
  }
  removeImage() {
    this.imageURL = '';
  }

  @Output() sendComment = new EventEmitter();
  onAddComment(value: string) {
    if ((!value || value.trim().length == 0) && this.imageURL.length == 0) {
      alert('댓글을 입력해 주세요.');
      return;
    }

    let comment = new CommentPost();
    comment.content = value;
    comment.image = this.imageURL

    if(this.isReply) {
      this.boardService.addByReplyComment(this.id, comment).subscribe(
        comment => {
          this.sendComment.emit(comment);
          this.gtmService.newCommentEvent({
            'title': this.board.title,
            'list': this.list,
            'date': this.datePipe.transform(this.board.createdDate, 'yyyyMMdd'),
            'author': this.board.author.nick || this.board.author.name
          })
          this.imageURL = ''
        }
      );
    }
    else {
      this.boardService.addByComment(this.id, comment).subscribe(
        comment => {
          this.sendComment.emit(comment);
          this.gtmService.newCommentEvent({
            'title': this.board.title,
            'list': this.list,
            'date': this.datePipe.transform(this.board.createdDate, 'yyyyMMdd'),
            'author': this.board.author.nick || this.board.author.name
          })
          this.imageURL = ''
        }
      );
    }
  }

  @Output() isChange = new EventEmitter();
  onChangeText(text) {
    this.isChange.emit(!!text.length)
  }

  @Output() closeReply = new EventEmitter();
  onCloseReply() {
    this.closeReply.emit();
  }
}



// WEBPACK FOOTER //
// ./src/app/member/shared/comment-register/comment-reg.component.ts